import { component } from 'picoapp';
import { gsap } from 'gsap';
import app from '../app';

export default component((node, ctx) => {
  const questions = node.querySelectorAll('.js-question');
  const prevButton = node.querySelector('.js-prev');
  const nextButton = node.querySelector('.js-next');
  const questionNumber = node.querySelector('.js-question-number');
  const error = node.querySelector('.js-error');
  const results = node.querySelector('.js-results');
  const resultsGrid = results.querySelector('.js-results-grid');
  const resultsFooter = results.querySelector('.js-results-footer');

  const enablePrevButton = () => prevButton.disabled = false;
  const disablePrevButton = () => prevButton.disabled = true;
  const enableNextButton = () => nextButton.disabled = false;
  const disableNextButton = () => nextButton.disabled = true;

  let currentQuestion = 0;
  let allProducts = null;

  function init() {
    fetchAllProducts().then(() => console.log(allProducts))
    currentQuestion = 0;
    initQuestion();
    updateListHeight();
    prevButton.addEventListener('click', prev);
    nextButton.addEventListener('click', next);
  }

  function prev() {
    saveQuestionData();
    if (currentQuestion > 0) {
      gsap.to(questions[currentQuestion], { autoAlpha: 0, x: 100 });
      currentQuestion--;
      
      gsap.fromTo(questions[currentQuestion],
        { autoAlpha: 0, x: -100 },
        { autoAlpha: 1, x: 0 });
      questionNumber.textContent = currentQuestion + 1;
      initQuestion();
      updateListHeight();
    }
  }

  function next() {
    saveQuestionData();
    if (currentQuestion < questions.length - 1) {
      gsap.to(questions[currentQuestion], { autoAlpha: 0, x: -100 });
      currentQuestion++;
      gsap.fromTo(questions[currentQuestion],
        { autoAlpha: 0, x: 100 },
        { autoAlpha: 1, x: 0 });
      questionNumber.textContent = currentQuestion + 1;
      initQuestion();
      updateListHeight();
    } else {
      submitAnswers();
    }
  }

  function updateListHeight() {
    const currentListHeight = questions[currentQuestion].querySelector('.c-quiz__answer-list').offsetHeight;
    const answersLists = document.querySelectorAll('.c-quiz__answers');
    for (let i = 0; i < answersLists.length; i++) {
      answersLists[i].style.maxHeight = `${currentListHeight}px`;
    }
  }

  function saveQuestionData() {
    const question = questions[currentQuestion];
    const form = question.querySelector('.js-form');
    const { question: id } = question.dataset;

    const quizAnswers = ctx.getState().quizAnswers || {};
    quizAnswers[id] = new FormData(form).getAll(id);
    ctx.hydrate({ quizAnswers });
  }

  function submitAnswers() {
    const tl = gsap.timeline();
    tl.to(questions[currentQuestion], { autoAlpha: 0, x: -100 });

    sendToGTM();

    fetchAllProducts()
      .then(() => getQuizResults(allProducts))
      .then((products) => {
        createProductCards(products);
        tl.fromTo(results, { autoAlpha: 0, x: 100 }, { autoAlpha: 1, x: 0 }, '>-0.2');
        tl.fromTo(resultsFooter, { autoAlpha: 0 }, { autoAlpha: 1 });
      });
  }

  function sendToGTM() {
    const { quizAnswers } = ctx.getState();
    dataLayer.push({
      'event': 'brew_method',
      'option_selected': quizAnswers['brew_method']
    });
    dataLayer.push({
      'event': 'milk',
      'option_selected': quizAnswers['milk']
    });
    dataLayer.push({
      'event': 'palate',
      'option_selected': quizAnswers['palate']
    });
    dataLayer.push({
      'event': 'flavour',
      'option_selected': quizAnswers['flavour']
    });
  }

  async function fetchAllProducts() {
    const url = window.location.origin + '/products.json?limit=300';
    if (allProducts) return allProducts;
    return fetch(url)
      .then(response => response.json())
      .then((result) => allProducts = result.products)
      .catch(e => console.error(e));
  }
  
  // function fetchMetafields(id) {
  //   const url = window.location.origin + '/admin/api/2022-10/products/' + id + '/metafields.json?key=subtitle';
  //   return fetch(url)
  //     .then(response => response.json())
  //     .then(result => {
  //       return result;
  //     })
  //     .catch(e => console.error(e));
  // }

  function getQuizResults() {
    const { quizAnswers } = ctx.getState();
    const byBrewMethod = allProducts.filter((product) => {
      return product.tags.includes(quizAnswers['brew_method'][0]);
    });
    const byMilkPreference = byBrewMethod.filter((product) => {
      return product.tags.includes(quizAnswers['milk'][0]);
    });
    const byPalate = byMilkPreference.filter((product) => {
      return product.tags.includes(quizAnswers['palate'][0]);
    });
    const byFlavours = byPalate.filter((product) => {
      return quizAnswers['flavour'].some(v => product.tags.includes(v));
    });
    return byFlavours.slice(0,3); // Only show top 3
  }

  async function fetchMetafieldData(handle) {
    const url = window.location.origin + '/products/' + handle;
    return fetch(url)
      .then((response) => response.text())
      .then((result) => {
        const html = new DOMParser().parseFromString(result, 'text/html');
        const flavourNotes = html.querySelector('.js-product-flavour-notes').innerHTML;
        const subtitle = html.querySelector('.js-product-subtitle').innerHTML;
        return { flavourNotes, subtitle };
      }).catch(e => console.error(e));
  }

  function createProductCards(products) {
    

    if (products.length === 0) {
      const error = document.createElement('p');
      error.classList.add('c-quiz__results-error');
      error.textContent = 'No products found';
      resultsGrid.appendChild(error);
    } else {
      resultsGrid.innerHTML = '';
      const template = node.querySelector('#product-card-template');

      products.forEach(async (product) => {
        const clone = template.content.cloneNode(true);
        resultsGrid.appendChild(clone);
        
        const card = resultsGrid.lastElementChild;
        
        
        const title = card.querySelectorAll('.js-product-title');
        const price = card.querySelector('.js-product-price');
        const image = card.querySelector('.js-product-image');

        // fetchMetafieldData(product.handle).then((response) => {
        //   const flavourNotes = card.querySelector('.js-product-flavour-notes');
        // const subtitle = card.querySelector('.js-product-subtitle');

        //   flavourNotes.textContent = response.flavourNotes;
        //   subtitle.textContent = response.subtitle;
        //   gsap.to([flavourNotes, subtitle], { autoAlpha: 1 });
        // });

        title.forEach((element) => element.textContent = product.title);
        
        price.textContent = '£' + product.variants[0].price;
        
        image.src = product.images[0].src;
        image.width = product.images[0].width;
        image.height = product.images[0].height;
        image.alt = product.images[0].alt;


        const productData = { 
          id: product.id, 
          title: product.title, 
          handle: product.handle, 
          options: product.options.filter((option) => option.values.length > 0), 
          variants: product.variants 
        };

        card.setAttribute('data-product-id', product.id);
        card.querySelector('.js-quick-add').setAttribute('data-product', btoa(JSON.stringify(productData)));

        app.emit('quiz:results');

        card.querySelectorAll('.js-product-link').forEach((link) => {
          link.href = window.location.origin + '/products/' + product.handle;
        });
      });
    }
  }

  function initQuestion() {
    const quizAnswers = ctx.getState().quizAnswers || {};

    const question = questions[currentQuestion];
    const form = question.querySelector('.js-form');
    const answers = question.querySelectorAll('.js-answer');
    const { answerType, question: id } = question.dataset;
    let selectedAnswers;

    currentQuestion == 0 ? disablePrevButton() : enablePrevButton();
    quizAnswers[id]?.length ? enableNextButton() : disableNextButton();

    answers.forEach((answer) => {
      answer.addEventListener('change', () => {
        selectedAnswers = new FormData(form).getAll(id);

        if (answerType === 'checkbox') {
          // Maximum of 3 answers
          if (selectedAnswers.length > 3) {
            answer.checked = false;
            showError('You can only select 3 answers');
          } else if (selectedAnswers.length) {
            enableNextButton();
          }
        } else {
          enableNextButton();
        }
      });
    });
  }

  function showError(text) {
    error.textContent = text;
    gsap.fromTo(error,
      { autoAlpha: 0, y: 0 },
      { autoAlpha: 1, y: ctx.getState().isMobile ? '-2rem' : '-4rem' });
  }

  init();
});


